import { render } from "./TopCountries.vue?vue&type=template&id=66449b4a&scoped=true"
import script from "./TopCountries.vue?vue&type=script&lang=js"
export * from "./TopCountries.vue?vue&type=script&lang=js"

import "./TopCountries.vue?vue&type=style&index=0&id=66449b4a&scoped=true&lang=css"

import exportComponent from "/home/forge/hike.marketing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66449b4a"]])

export default __exports__